/**
 * Zngly Inbound
 * Tracks inbound traffic from external sources
 * Data will then be sent to GA4 to fill in the missing data for bigquery.
 *
 * https://support.google.com/analytics/answer/9143382#session-metrics&zippy=%2Csession
 * Engaged sessions -   The number of sessions that lasted 10 seconds or longer,
 *                      or had 1 or more conversion events or 2 or more page or screen views.
 *
 */

import { Analytics, TelemetryRunner } from '@/Telemetry';
import { get } from './Inbound';
import { CookieHandler } from './cookie-init';

class ZnglyInbound {
  public constructor() {
    TelemetryRunner.addGtagLoadedFunction(() => {
      this.run();
    });
  }

  private run() {
    // if the referrer is the same as the current domain we are browsing, no need to track this;
    try {
      if (!!document?.referrer && new URL(window.location.href).origin === new URL(document.referrer).origin) return;

      const data = get();
      if (data == null || Object.keys(data).length === 0) return;

      Analytics.push(
        'zngly_inbound',
        {
          ...data,
          userType: Analytics.data().userType,
          clientId: CookieHandler.getZnClientId(),
        },
        false
      );
    } catch (e) {
      // @todo: log error
    }
  }
}

export default ZnglyInbound;
